import { ChangeDetectionStrategy, Component, effect, input, model, output } from '@angular/core';

@Component({
  selector: 'app-modifica-note-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Modifica Note" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" >

    <label for="note" class="small-label">Note</label>
    <textarea pInputTextarea id="note" rows="10" cols="80" [(ngModel)]="_note"></textarea>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-check" label="Salva" (click)="changeNote_click()"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  #note { min-height: 50px!important}
  `]
})
export class ModificaNoteDialogComponent {
  visible = model<boolean>(false);
  note = input.required<string>();

  hide = output();
  noteChanged = output<string>();

  _note = '';

  constructor() {
    effect(() => {
      if (this.visible()) {
        this._note = this.note();
      }
    });
  }

  changeNote_click() {
    this.noteChanged.emit(this._note);
  }

  hideDialog() {
    this.hide.emit();
  }
}
